import { render } from "./widgetBlog.vue?vue&type=template&id=1807e831&ts=true"
import script from "./widgetBlog.vue?vue&type=script&lang=ts"
export * from "./widgetBlog.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./widgetBlog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__